"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTaxDetails = void 0;
var transformTaxDetails = function (taxDetails, formattedTaxDetails) {
    var clientTaxDetails = [];
    for (var i = 0; i < taxDetails.length; i++) {
        var _a = taxDetails[i], tax = _a.tax, label = _a.label;
        var taxWithCurrencyFormat = formattedTaxDetails[i].tax;
        clientTaxDetails.push({
            tax: tax,
            label: label,
            taxWithCurrencyFormat: taxWithCurrencyFormat,
        });
    }
    return clientTaxDetails;
};
exports.transformTaxDetails = transformTaxDetails;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/common/transforms/transformTaxDetails.js
// module id = 3375
// module chunks = 11